import { useCallback, useRef, useState } from "react";
import { PageHeader } from "@/components/ui/PageHeader";
import { showToast } from "@/components/ui/Toast";
import { ConsultaNitsForm } from "@/components/features/confecamaras/ConsultaNitsForm";
import { ConsultaResultadosTable } from "@/components/features/confecamaras/ConsultaResultadosTable";
import { LimpiarConsultaButton } from "@/components/features/confecamaras/LimpiarConsultaButton";
import type { ProgresoConsulta } from "@/api/confecamaras";
import type { ConsultaNitsFormHandle } from "@/components/features/confecamaras/ConsultaNitsForm";

export const ConfecamarasPage = () => {
  const [resultados, setResultados] = useState<ProgresoConsulta[]>([]);
  const formRef = useRef<ConsultaNitsFormHandle>(null);

  const limpiar = useCallback(() => {
    formRef.current?.reset();
    setResultados([]);
    showToast("info", "Formulario limpio", "Ingresa nuevos NITs para una nueva consulta");
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-4">
        <PageHeader
          title="Consulta de NIT — Confecámaras"
          subtitle="Fuente: datos.gov.co hasta 100 NITs por consulta · las consultas no se almacenan"
        />
        <LimpiarConsultaButton onClear={limpiar} />
      </div>

      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <div
            className="border-accent-blue text-accent-blue whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium"
          >
            Consultar
          </div>
          <a
            href="https://www.rues.org.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium flex items-center gap-1"
          >
            RUES (Consultar RUTs)
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </nav>
      </div>

      <div className="space-y-4 pt-2">
        <ConsultaNitsForm ref={formRef} onResultados={setResultados} />
        <ConsultaResultadosTable resultados={resultados} />
      </div>
    </div>
  );
};
